<template>
    <div>
        <menu-bar></menu-bar>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/pontos"><i class="fa fa-suitcase" aria-hidden="true"></i> REPETIDORES</a></li>
                    <li class="active">CADASTRO DE REPETIDORES</li>
                </ol>

                <div class="col-md-3">
                    <repetidor-menu :ponto_id="repetidor_id"></repetidor-menu>
                </div>

                <div class="col-md-9" v-if="repetidor">
                    <router-view></router-view>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { RepetidorMenu } from "../../../components/exports";
import pontoMixin from "../../mixins/repetidores";
import pontoComputedMixin from "../../mixins/repetidores_computed";
export default {
    components: { RepetidorMenu },
    mixins: [pontoMixin, pontoComputedMixin]
};
</script>
